import { useTranslation } from "react-i18next";
import { useOperationsMap } from "../OperationsMapProvider";
import { Box, Button, Skeleton, Stack } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { HeatmapLayerSettings } from "../map/plugins/HeatmapLayer";
import { TrafficLayerSettings } from "../map/plugins/TrafficWarnings";
import { VehiclesLayerSettings } from "../map/plugins/VehiclesLayer";
import { MyLocationsLayerSettings } from "../map/plugins/MyLocationsLayer";
import { DispatchLayerSettings } from "../map/plugins/DispatchLayer";
import { Cached as CachedIcon } from "@mui/icons-material"
import { AssistNetworkLayerSettings } from "../map/plugins/AssistNetworkLayer";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      marginLeft: `calc(var(--scrollbar-width) * -1)`,
      marginRight: `calc(var(--scrollbar-width) * -1)`,
      padding: theme.spacing(1.5)
    },
    resetButtonBox: {
      width: "100%",
      justifyContent: "center",
      display: "flex",
      padding: theme.spacing(2),
      paddingBottom: theme.spacing(0)
    },
    skeleton: {
      margin: theme.spacing(1),
      marginBottom: 0,
      borderRadius: theme.spacing(2),
      width: "100%"
    }
  })
);

export default function LayerSettingsPanel() {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { operationsMap, resetSettings, loaded } = useOperationsMap();

  return !!operationsMap ? (
    <Stack className={classes.root} spacing={1}>
      {
        loaded ? (
          <>
            <DispatchLayerSettings />

            <VehiclesLayerSettings />

            <MyLocationsLayerSettings />

            <TrafficLayerSettings />

            <HeatmapLayerSettings />

            <AssistNetworkLayerSettings />

            <Box className={classes.resetButtonBox}>
              <Button onClick={resetSettings} color="neutral" variant="contained" startIcon={<CachedIcon />}>
                {t("operationsMap:resetSettings")}
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Skeleton className={classes.skeleton} variant="rounded" height="220px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="160px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="240px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="40px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="40px" />
            <Skeleton className={classes.skeleton} variant="rounded" height="40px" />
          </>
        )
      }
    </Stack>
  ) : null;
}

